import { put, call, takeLatest, all } from 'redux-saga/effects';
import ModificationLogTypes from './types';
import request from 'utils/request';
import { DEFAULT_ERROR_MESSAGE } from 'utils/constants';
import urls from 'utils/config';
import {
  fetchModificationLogSuccess,
  fetchModificationLogFailure,
} from './actions';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* fetchModificationLog({ data }) {
  const { size = 10, timeframe = [], search, operation, page = 0 } = data;
  const url = `${API_BASE_URL}/audit/mofication-log?limit=${size}&offset=${page}${
    search ? `&username=${encodeURIComponent(search)}` : ''
  }${operation ? `&on=${operation}` : ''}${
    timeframe.length ? `&from=${timeframe[0].toISOString()}` : ''
  }${timeframe.length ? `&to=${timeframe[1].toISOString()}` : ''}`;

  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    yield put(fetchModificationLogSuccess(response.raw));
  } else {
    yield put(fetchModificationLogFailure(DEFAULT_ERROR_MESSAGE));
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

function* onFetchModificationLog() {
  yield takeLatest(
    ModificationLogTypes.FETCH_MODIFICATION_LOG_START,
    fetchModificationLog
  );
}

export function* modificationLogSagas() {
  yield all([call(onFetchModificationLog)]);
}
